var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.form.config.template == 'register')?_c('Register',{attrs:{"view":_vm.view,"formLink":_vm.formLink}}):_c('Standard',{attrs:{"view":_vm.view,"formLink":_vm.formLink}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }